var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSolarPowerBlack01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1080 1080",
    style: {
      enableBackground: "new 0 0 1080 1080"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M142.2,140c-15,0-25-5-35-15s-15-20-15-35s5-25,15-35s20-15,35-15h50c15,0,25,5,35,15c10,10,15,20,15,35s-5,25-15,35 c-10,10-20,15-35,15H142.2z M182.2,840l-20,100h325V840H182.2z M212.2,300l35-35c10-10,20-15,35-15s25,5,35,15c10,10,15,20,15,35 s-5,25-15,35l-35,35c-10,10-20,15-35,15s-25-5-35-15c-10-10-15-20-15-35C197.2,320,202.2,310,212.2,300z M202.2,740h290V640h-270 L202.2,740z M542.2,290c-70,0-130-25-175-75c-50-50-75-110-75-175h100c0,40,15,75,45,105c30,30,65,45,105,45c40,0,75-15,105-45 c30-30,45-65,45-105h100c0,70-25,130-75,175C667.2,265,612.2,290,542.2,290z M492.2,440v-50c0-15,5-25,15-35c10-10,20-15,35-15 c15,0,25,5,35,15s15,20,15,35v50c0,15-5,25-15,35s-20,15-35,15c-15,0-25-5-35-15C497.2,465,492.2,450,492.2,440z M592.2,940h325 l-20-100h-305V940z M592.2,740h290l-20-100h-265v100H592.2z M797.2,370l-35-35c-10-10-15-20-15-35s5-25,15-35c10-10,20-15,35-15 c15,0,25,5,35,15l35,35c10,10,15,20,15,35c0,15-5,25-15,35s-20,15-35,15C822.2,385,807.2,380,797.2,370z M942.2,140h-100V40h100 c15,0,25,5,35,15s15,20,15,35s-5,25-15,35S957.2,140,942.2,140z M62.3,920l60-300c5-25,15-40,35-55c20-15,40-25,65-25h635 c25,0,45,5,65,25c20,15,30,35,35,55l60,300c5,30,0,60-20,85c-20,25-45,35-80,35h-755c-30,0-60-10-80-35C67.3,980,57.3,950,62.3,920z "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolarPowerBlack01);
export default __webpack_public_path__ + "static/media/solar-power-black-01.5ac8a76f8dcfb0cc4bb7b0faf46f981c.svg";
export { ForwardRef as ReactComponent };